import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import * as O from 'fp-ts/lib/Option';
import {PremiumMode} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';

export class InvalidChangePayrollAllotment {
  public readonly key = 'InvalidChangePayrollAllotment';

  constructor(
    public readonly accountNumber: StringUnion,
    public readonly controlNumber: StringUnion,
    public readonly payorName: StringUnion,
    public readonly billingSchedule: O.Option<PremiumMode>
  ) {}
}
export class ValidChangePayrollAllotment {
  public static create(
    accountNumber: StringUnion,
    controlNumber: StringUnion,
    payorName: StringUnion,
    billingSchedule: O.Option<PremiumMode>
  ) {
    return isNonEmptyString(accountNumber) &&
      isNonEmptyString(controlNumber) &&
      isNonEmptyString(payorName) &&
      O.isSome(billingSchedule)
      ? new ValidChangePayrollAllotment(accountNumber, controlNumber, payorName, billingSchedule)
      : new InvalidChangePayrollAllotment(accountNumber, controlNumber, payorName, billingSchedule);
  }

  public readonly key = 'ValidChangePayrollAllotment';

  private constructor(
    public readonly accountNumber: NonEmptyString,
    public readonly controlNumber: NonEmptyString,
    public readonly payorName: NonEmptyString,
    public readonly billingSchedule: O.Some<PremiumMode>
  ) {}
}

export const isValidPayrollAllotment = (
  payrollAllotment: PayrollAllotmentChangeRequest
): payrollAllotment is ValidChangePayrollAllotment => payrollAllotment.key === 'ValidChangePayrollAllotment';

export type PayrollAllotmentChangeRequest = ValidChangePayrollAllotment | InvalidChangePayrollAllotment;

export const EmptyChangePayrollAllotment: PayrollAllotmentChangeRequest = new InvalidChangePayrollAllotment(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  O.none
);
